module.exports = __webpack_public_path__ + "static/media/S (38).00c07c47.jpg";